// components/BestWorksCarousel.js
import React from "react";

import ghckLogo from "../assets/gulf.png";
import septaLogo from "../assets/nobg.png";
import zivukoLogo from "../assets/zivuko-nobg.png";
import emberLogo from "../assets/ember-logo.png";
import longLogo from "../assets/second.png";
import asiyoLogo from "../assets/asiyo-nobg.png";
import jengaLogo from "../assets/jenga.png";
import wwcLogo from "../assets/logo-me-1.png";
import marketplaceLogo from "../assets/market-2.png";
import williamLogo from "../assets/logo-no.png";
import remunaryLogo from "../assets/1-nobg.png";

const works = [
  {
    id: 1,
    name: "Gulf Medical",
    logo: ghckLogo,
    website: "https://www.ghck.co.ke",
  },
  {
    id: 2,
    name: "SeptaGreen Africa",
    logo: septaLogo,
    website: "https://septagreen.onrender.com",
  },
  {
    id: 3,
    name: "Zivuko Kenya",
    logo: zivukoLogo,
    website: "https://zivuko-marketplace-kenya.onrender.com",
  },
  {
    id: 4,
    name: "Emberprise Africa",
    logo: emberLogo,
    website: "https://emberprise.netlify.app/",
  },
  {
    id: 5,
    name: "Longclause",
    logo: longLogo,
    website: "/about",
  },
  {
    id: 6,
    name: "Asiyo Women Connect",
    logo: asiyoLogo,
    website: "https://www.asiyoconnect.com",
  },
  {
    id: 7,
    name: "JengaWork Kenya",
    logo: jengaLogo,
    website: "/about",
  },
  {
    id: 8,
    name: "William Writes Code",
    logo: wwcLogo,
    website: "/",
  },
  {
    id: 9,
    name: "Asiyo Marketplace",
    logo: marketplaceLogo,
    website: "https://shop.asiyoconnect.com",
  },
  {
    id: 10,
    name: "William Sisulu Odhiambo",
    logo: williamLogo,
    website: "/",
  },
  {
    id: 11,
    name: "Remunary",
    logo: remunaryLogo,
    website: "/about",
  },
];

function WorkLogoCard({ work }) {
  const handleWorkClick = () => {
    if (!work.website) return;

    if (work.website.startsWith("http")) {
      window.open(work.website, "_blank", "noopener,noreferrer");
      return;
    }

    window.location.href = work.website;
  };

  return (
    <button
      type="button"
      onClick={handleWorkClick}
      title={work.name}
      aria-label={`View ${work.name}`}
      className="group flex h-32 w-full items-center justify-center rounded-xl bg-transparent px-6 py-5 transition duration-300 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[var(--brand-green)] sm:h-36 md:h-40 lg:h-36 xl:h-40"
    >
      <img
        src={work.logo}
        alt={`${work.name} logo`}
        loading="lazy"
        className="max-h-24 max-w-[12rem] object-contain opacity-100 transition duration-500 group-hover:scale-110 sm:max-h-28 sm:max-w-[14rem] md:max-h-32 md:max-w-[15rem] lg:max-h-28 xl:max-h-32 xl:max-w-[16rem]"
      />
    </button>
  );
}

const BestWorksCarousel = ({
  worksList = works,
  title = "Selected Work",
  subtitle = "Systems, platforms, and digital products connected to William's work.",
}) => {
  return (
    <section className="relative overflow-hidden bg-white text-black">
      <div className="mx-auto grid min-h-[88vh] w-full max-w-[1600px] gap-14 px-5 py-24 sm:px-8 md:grid-cols-[0.75fr_1.45fr] md:items-center md:px-10 lg:gap-20 lg:px-14 xl:px-20">
        <div className="md:pb-20">
          <h2 className="max-w-md text-[clamp(2.2rem,4.2vw,4.8rem)] font-light leading-[0.95] tracking-[-0.075em] text-black">
            {title}
          </h2>

          <p className="mt-6 max-w-md text-base font-light leading-7 tracking-[-0.02em] text-black/55 sm:text-lg">
            {subtitle}
          </p>

          <a
            href="/contact"
            className="mt-8 inline-flex h-12 items-center justify-center rounded-full border border-black/15 px-6 text-xs font-bold uppercase tracking-[0.18em] text-black transition duration-300 hover:border-black hover:bg-black hover:text-white"
          >
            Start a Project
          </a>
        </div>

        <div className="grid grid-cols-2 gap-x-10 gap-y-12 sm:grid-cols-3 sm:gap-x-12 sm:gap-y-14 md:grid-cols-3 lg:grid-cols-4 lg:gap-x-16 lg:gap-y-16 xl:grid-cols-4 xl:gap-x-20 xl:gap-y-20">
          {worksList.map((work) => (
            <WorkLogoCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestWorksCarousel;